module.exports = __webpack_public_path__ + "img/video.5070636c.svg";